import axios from 'axios';

// Retrieve the API base URL and API Key from environment variables
const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:5002'; // Fallback if not set
const API_KEY = process.env.REACT_APP_BACKEND_API_KEY;

// Basic validation: Check if the API Key environment variable is set.
// In a real application, you might want more robust checks or error handling.
if (!API_KEY || API_KEY === 'YOUR_STRONG_FRONTEND_KEY_PLACEHOLDER') {
  console.warn(
    `Warning: REACT_APP_BACKEND_API_KEY is not set or is using the placeholder value in the environment variables. ` +
    `API calls to protected backend endpoints might fail.`
  );
  // Depending on your needs, you might throw an error here during development builds
  // to enforce setting the key, e.g., if (process.env.NODE_ENV === 'development') { ... }
}

// Create an Axios instance with default configuration
// Ensure Axios doesn't try to initialize with an empty string if error occurred above
const axiosInstance = axios.create({
  baseURL: API_BASE_URL || undefined, // Use undefined if base URL is invalid/missing in prod
  withCredentials: true, // Important for sending session cookies if needed for other auth
});

// Add an interceptor to include the API key in the headers of every request
// made with this instance, but only if the key is actually set.
if (API_KEY && API_KEY !== 'YOUR_STRONG_FRONTEND_KEY_PLACEHOLDER') {
  axiosInstance.interceptors.request.use(
    (config) => {
      // Add the X-API-Key header
      config.headers['X-API-Key'] = API_KEY;
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );
} else {
  // Log a warning if the API key is missing or still the placeholder,
  // as requests to protected routes will likely fail.
  console.warn('API Key is missing or invalid; X-API-Key header will not be sent.');
}


export default axiosInstance;